const NotFoundPage = () => {
  return <div>Not found</div>;
};
export default NotFoundPage;
